import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VeeValidate from 'vee-validate';
import Axios from 'axios';
import router from './router';
import store from './store';
import { sync } from 'vuex-router-sync';
import * as helpers from 'utils/helpers';
import App from 'components/app-root';


window.onerror = function (errorMsg, url, lineNumber, column, errorObj) {
  console.error(errorMsg);
  // Update Vuex error state (if modal is to be presented in app-root.vue),
  // or navigate via vue-router to error view.
  router.push('/error');
  return false;
};

window.onunhandledrejection = function (event) {
  console.error(event.reason ? event.reason.message : null);
  router.push('/error');
  return false;
};

Vue.config.errorHandler = function (err, vm, info) {
	console.error(info);
  router.push('/error');
}

var appElement = document.querySelector('#app');
var appBase = appElement && appElement.getAttribute('appbase') || '';
var hrefBase = appElement && appElement.getAttribute('hrefbase') || '';
var displayMode = appElement && appElement.getAttribute('displaymode') || '';
var axios = Axios.create({
  baseURL: hrefBase
});

// Only use truly global behavior as interceptors.
/*
axios.interceptors.response.use(function (response) {
 if (response.status === 200 && response.data && response.data.redirectUrl) {
  location.href = response.data.redirectUrl;
 }
 return response;
});
*/
axios.interceptors.request.use(function (config) {
  store.commit('beginRequest');
  return config;
}, function (error) {
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  store.commit('endRequest');
  return response;
}, function (error) {
  // This error handler executes before the action-specific error handler.
  store.commit('endRequest');
  if (error && error.response && error.response.status) {
    let httpStatusCode = Number(error.response.status);
    // Handle network errors (HTTP 400 and above) if necessary,
    // but let HTTP 400 Bad Request pass through
    // because that is treated as a model validation error.
  }

  return Promise.reject(error);
});

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en', 
  fallbackLocale: 'es',
  silentTranslationWarn: false
});

Vue.use(VeeValidate, {
  events: '',
  i18n: i18n,
  i18nRootKey: 'validation'
});

Vue.prototype.$http = axios;
Vue.prototype.$appBase = appBase;
Vue.prototype.$hrefBase = hrefBase;
Vue.prototype.$displayMode = displayMode; 
Vue.directive('focus', {
  inserted: function (el) {
    el.focus();
  }
});

sync(store, router);

const app = new Vue({
  store,
  router,
  i18n,
  ...App,
  methods: {
    ...helpers
  }
});

export {
  app,
  router,
  store
};
